export class CreatePurchaseOrder {
  public orderDetails: number[];
}
export class AdminOrderDetail {
  public id: string;
  public purchaseOrderDetailID: number;
  public purchaseOrderID: number;
  public orderDetailID: number;
  public vendorID: number;
  public productID: number;
  public brandID: number;
  public categoryID: number;
  public price: number;
  public quantity: number;
  public purchaseOrder: any;
  public salePrice: number;
  public regularPrice : number;
  public commissionPrices : number;
  public commissionType : string;
  public appliedDiscoutType : string;
  public appliedDiscoutedAmount : number;
  public profit  :number;

}
export class AdminOrder {
  public purchaseOrderID: number;
  public orderID: number;
  public vendorID: number;
  public orderDate: number;
  public shippingPrice: number;
  public orderStatus: number;
  public orderIds: string;
  public orderDetails: any[];
  public fullName: string;
  public totalRecords: number;
  public checked: boolean = false;

}



// WEBPACK FOOTER //
// ./src/app/models/PurchaseOrder/create-purchase-order.model.ts